module.exports = __webpack_public_path__ + "static/img/3.5ba206a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/3.png
// module id = /v4k
// module chunks = 0